/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2021 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


 export const Tooltip=(tooltip) =>{

    let temp = '<div class="col tooltipBox ">' +
        ' <div class="row">' +
        ' <div class="col-md-12 tooltipDesc">' +
        tooltip.description +
        ' </div></div>';

    tooltip.tags.map((val) => {
        let items = (val["items"] != null) ? val["items"].split('__') : [];
        if (val["items"] != null) {
            temp += ' <div class="row tooltipTags">';
            temp += ' <label class="tooltipLabel ">' + val["key"] + '</label>';

            items.map((tags) => {
                temp += ' <span class="tag-font recent-tags">' + tags + '</span>';
            })
            temp += '</div >';
        }
    })
    temp+= '  </div >';
     return temp;
}